import { render, staticRenderFns } from "./ContactListProvider.vue?vue&type=template&id=2171ccef&scoped=true&"
import script from "./ContactListProvider.vue?vue&type=script&lang=ts&"
export * from "./ContactListProvider.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2171ccef",
  null
  
)

export default component.exports